import React from "react";
import Breadcrumb from "../atoms/Breadcrumb";
import CategoryInfoCarousel from "../organisms/CategoryInfoCarousel";
import Head from "next/head";
import Container from "../atoms/Container";
import Heading from "../atoms/Heading";
import CategoryInfoView from "../organisms/CategoryInfoView";

const CategoryTemplate = ({ allCategories }) => {
    const data = [
        { name: "Home", path: "/", isActive: false },
        { name: "Brands", path: "/categories", isActive: false },
    ];

    return (
        <div>
            <Head>
                <title>KashKounter - Earn Cashback on your favourite local and international brands</title>
            </Head>
            <Container type='type0'>
                <Breadcrumb className="py-5 md:py-10" divider="primary" textSize={"text-sm"} data={data} />
                <div className="pb-12 md:-mt-[4.9rem]">
                    <Heading type="h2" className="text-center text-3xl md:text-6xl font-bold text-primary-900 uppercase">
                        Let's Shop!
                    </Heading>
                    <div className="hidden md:block">
                        {allCategories.map((info, index) => (
                            <CategoryInfoCarousel categoryTitle={info.name} merchantCard={info.Merchants} key={index} />
                        ))}
                    </div>
                    <div className="block md:hidden">
                        {allCategories.map((info, index) => (
                            <CategoryInfoView categoryTitle={info.name} merchantCard={info.Merchants} key={index} />
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default CategoryTemplate;
